/* eslint-disable vue/no-unused-vars */
<template>
  <div>
    <a-card style="margin-bottom: 1rem;" class="card">
      <div slot="title">
        <a-button
          type="primary"
          size="small"
          icon="left"
          shape="circle"
          class="back-button"
          style="margin-right: 1rem;"
          @click="backButton"
        />
        <span v-if="isAdd" class="hover-title main-card-title"
          ><a-icon type="link" style="margin-right: 5px;"></a-icon>NUEVO LINK DE
          PAGO</span
        >
        <span v-else class="hover-title">
          <a-skeleton
            v-if="loading"
            :paragraph="{ rows: 0 }"
            active
          ></a-skeleton>
          <span v-else class="main-card-title">
            <a-icon type="link" style="margin-right: 5px;"></a-icon
            >{{ paymentLink.name }}
            <span style="font-size: 1rem;">id: #{{ paymentLink.id }}</span>
          </span>
        </span>
        <!--<a-icon @click="backButton()" type="arrow-left">Volver </a-icon>-->
      </div>

      <a-form class="add-form" :form="form" @submit="handleSubmit" novalidate>
        <a-form-item has-feedback>
          <a-input
            name="name"
            ref="initial"
            placeholder="Título"
            v-decorator="[
              'name',
              {
                //getValueFromEvent: formatCardNumber,
                rules: [
                  {
                    required: true,
                    message: 'Por favor, ingrese el título.'
                  }
                ]
              }
            ]"
          >
            <a-icon
              slot="prefix"
              type="font-size"
              style="color: rgba(0, 0, 0, 0.25);"
            />
          </a-input>
        </a-form-item>

        <a-form-item has-feedback>
          <a-textarea
            name="description"
            ref="description"
            placeholder="Descripción"
            v-decorator="[
              'description',
              {
                rules: [
                  {
                    required: false
                  }
                ]
              }
            ]"
          >
            <a-icon
              slot="prefix"
              type="font-size"
              style="color: rgba(0, 0, 0, 0.25);"
            />
          </a-textarea>
        </a-form-item>
        <!--
        <a-form-item
          has-feedback
          :validate-status="amount.validateStatus"
          :help="amount.errorMsg"
        >
          <a-input-number
            ref="amount"
            name="amount"
            pattern="[0-9]*"
            placeholder="Precio"
            :formatter="
              value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            "
            :parser="value => value.replace(/\$\s?|(,*)/g, '')"
            class="add-form"
            v-decorator="['amount', {}]"
          >
          </a-input-number>
        </a-form-item>
        -->

        <a-form-item
          has-feedback
          :help="'El precio solo acepta números y el punto (.) para decimal'"
        >
          <a-input-number
            ref="amount"
            name="amount"
            pattern="[0-9]*"
            placeholder="Precio"
            class="add-form"
            v-decorator="[
              'amount',
              {
                rules: [
                  {
                    required: true,
                    message: 'Por favor, ingrese el precio.'
                  },
                  {
                    type: 'number',
                    message: 'Solo se aceptan numeros con . para el decimal'
                  }
                ]
              }
            ]"
          >
          </a-input-number>
        </a-form-item>
        <!--
        <a-form-item has-feedback>
          <a-auto-complete
            placeholder="Seleccionar el producto"
            this.loadingProducts
            @dropdownVisibleChange="loadProducts()"
            @change="handleProductChange"
            :notFoundContent="loadingProducts ? undefined : null"
            :filter-option="filterProducts"
            v-decorator="[
              'productId',
              {
                //getValueFromEvent: formatCardNumber,
                rules: [
                  {
                    required: true,
                    message: 'Por favor, ingrese el producto.'
                  }
                ]
              }
            ]"
          >
            <template slot="dataSource">
              <a-select-opt-group>
                <span slot="label"><a-icon type="tags" /> Suscripciones</span>
                <a-select-option
                  v-for="item in this.products.group1"
                  :key="item.id"
                  >{{ item.name }}&nbsp;<span style="color:#ccc; font-size:10px"
                    >-&nbsp;{{ item.ERPCode }}</span
                  ></a-select-option
                ></a-select-opt-group
              >
              <a-select-opt-group>
                <span slot="label"
                  ><a-icon type="codepen" /> Otros Productos</span
                >
                <a-select-option
                  v-for="item in this.products.group2"
                  :key="item.id"
                  >{{ item.name }}&nbsp;<span style="color:#ccc; font-size:10px"
                    >-&nbsp;{{ item.ERPCode }}</span
                  ></a-select-option
                >
              </a-select-opt-group>
            </template>
          </a-auto-complete>

          <a-tooltip
            title="El producto determina el tipo de curso/actividad. Ej: Happiness Program"
            placement="right"
            ><a-icon
              type="question-circle-o"
              class="tooltip-icon tooltip-top"
            />
          </a-tooltip>
        </a-form-item>
-->

        <a-form-item has-feedback>
          <a-select
            placeholder="Seleccionar el producto"
            this.loadingProducts
            @dropdownVisibleChange="loadProducts()"
            @change="handleProductChange"
            :showSearch="true"
            :filter-option="filterProducts"
            option-filter-prop="children"
            :notFoundContent="loadingProducts ? undefined : null"
            v-decorator="[
              'productId',
              {
                //getValueFromEvent: formatCardNumber,
                rules: [
                  {
                    required: true,
                    message: 'Por favor, ingrese el producto.'
                  }
                ]
              }
            ]"
          >
            <a-spin
              v-if="loadingProducts"
              slot="notFoundContent"
              size="small"
            />
            <a-select-opt-group>
              <span slot="label"><a-icon type="tags" /> Suscripciones</span>
              <a-select-option
                v-for="item in filteredProducts.group1"
                :key="item.id"
                >{{ item.name }}&nbsp;<span
                  style="color: #ccc; font-size: 10px;"
                  >-&nbsp;{{ item.ERPCode }}</span
                ></a-select-option
              ></a-select-opt-group
            >
            <a-select-opt-group>
              <span slot="label"
                ><a-icon type="codepen" /> Otros Productos</span
              >
              <a-select-option
                v-for="item in filteredProducts.group2"
                :key="item.id"
                >{{ item.name }}&nbsp;<span
                  style="color: #ccc; font-size: 10px;"
                  >-&nbsp;{{ item.ERPCode }}</span
                ></a-select-option
              >
            </a-select-opt-group>
          </a-select>

          <a-tooltip
            title="El producto determina el tipo de curso/actividad. Ej: Happiness Program"
            placement="right"
            ><a-icon
              type="question-circle-o"
              class="tooltip-icon tooltip-top"
            />
          </a-tooltip>
        </a-form-item>

        <a-form-item has-feedback v-if="displayCascader">
          <a-cascader
            :options="cascaderOptions"
            :loadData="loadCascaderData"
            :disabled="cascaderDisabled"
            placeholder="Seleccionar el centro de costos"
            changeOnSelect
            v-decorator="[
              'costCenter',
              {
                //getValueFromEvent: formatCardNumber,
                rules: [
                  {
                    required: true,
                    message: 'Por favor, ingrese el centro de costos.'
                  }
                ]
              }
            ]"
          >
            <!--
            <template
              slot="displayRender"
              slot-scope="{ labels, selectedOptions }"
            >
              <span
                v-for="(label, index) in labels"
                :key="selectedOptions[index].value"
              >
                <span v-if="index === labels.length - 1">
                  {{ label }}
                </span>
              </span>
            </template>
            -->
          </a-cascader>
          <a-tooltip
            title="El centro de costos determina el curso/actividad especifico/a. Ej: HP437"
            placement="right"
            ><a-icon
              type="question-circle-o"
              class="tooltip-icon tooltip-top"
            />
          </a-tooltip>
        </a-form-item>

        <a-form-item has-feedback v-else>
          <a-select
            placeholder="Seleccionar el centro de costos"
            @dropdownVisibleChange="loadCostCenters()"
            @change="handleCostCenterChange"
            :notFoundContent="loadingCCs ? undefined : null"
            :disabled="costCenterDisabled"
            v-decorator="[
              'costCenterERPCode',
              {
                //getValueFromEvent: formatCardNumber,
                rules: [
                  {
                    required: true,
                    message: 'Por favor, ingrese el centro de costos.'
                  }
                ]
              }
            ]"
          >
            <a-spin v-if="loadingCCs" slot="notFoundContent" size="small" />
            <a-select-option
              v-for="item in this.costCenters"
              :key="item.ERPCode"
              >{{ item.name }}&nbsp;<span style="color: #ccc; font-size: 10px;"
                >-&nbsp;{{ item.ERPCode }}</span
              ></a-select-option
            >
          </a-select>
          <a-tooltip
            title="El centro de costos determina el curso/actividad especifico/a. Ej: HP437"
            placement="right"
            ><a-icon
              type="question-circle-o"
              class="tooltip-icon tooltip-top"
            />
          </a-tooltip>
        </a-form-item>

        <a-form-item has-feedback>
          <a-select
            placeholder="Seleccionar la unidad de negocios"
            @dropdownVisibleChange="loadBusinessUnits()"
            :notFoundContent="loadingBUs ? undefined : null"
            ref="businessUnitSelect"
            v-decorator="[
              'businessUnitId',
              {
                //getValueFromEvent: formatCardNumber,
                rules: [
                  {
                    required: true,
                    message: 'Por favor, ingrese la unidad de negocios.'
                  }
                ]
              }
            ]"
          >
            <a-spin v-if="loadingBUs" slot="notFoundContent" size="small" />
            <a-select-opt-group>
              <span slot="label"><a-icon type="shop" /> Sedes</span>
              <a-select-option
                v-for="item in this.businessUnits.group1"
                :key="item.id"
                >{{ item.name }}&nbsp;<span
                  style="color: #ccc; font-size: 10px;"
                  >-&nbsp;{{ item.ERPCode }}</span
                ></a-select-option
              >
            </a-select-opt-group>
            <a-select-opt-group>
              <span slot="label"><a-icon type="bank" /> Oficinas</span>
              <a-select-option
                v-for="item in this.businessUnits.group2"
                :key="item.id"
                >{{ item.name }}&nbsp;<span
                  style="color: #ccc; font-size: 10px;"
                  >-&nbsp;{{ item.ERPCode }}</span
                ></a-select-option
              >
            </a-select-opt-group>
            <a-select-opt-group>
              <span slot="label"><a-icon type="environment" /> Zonas</span>
              <a-select-option
                v-for="item in this.businessUnits.group3"
                :key="item.id"
                >{{ item.name }}&nbsp;<span
                  style="color: #ccc; font-size: 10px;"
                  >-&nbsp;{{ item.ERPCode }}</span
                ></a-select-option
              >
            </a-select-opt-group>
            <a-select-opt-group>
              <span slot="label"><a-icon type="environment" /> Paises</span>
              <a-select-option
                v-for="item in this.businessUnits.group4"
                :key="item.id"
                >{{ item.name }}&nbsp;<span
                  style="color: #ccc; font-size: 10px;"
                  >-&nbsp;{{ item.ERPCode }}</span
                ></a-select-option
              >
            </a-select-opt-group>
            <a-select-option
              v-for="item in this.businessUnits.noGroup"
              :key="item.id"
              >{{ item.name }}&nbsp;<span style="color: #ccc; font-size: 10px;"
                >-&nbsp;{{ item.ERPCode }}</span
              ></a-select-option
            >
          </a-select>
          <a-tooltip
            title="La unidad de negocios determina quien recibirá los ingresos del curso/actividad. Ej: Sede Uriburu"
            placement="right"
            ><a-icon
              type="question-circle-o"
              class="tooltip-icon tooltip-top"
            />
          </a-tooltip>
        </a-form-item>

        <a-form-item has-feedback>
          <div :class="$style.optionTitle">
            Finalización Automática:
          </div>
          <a-date-picker
            v-decorator="['endDate', {}]"
            :format="'DD/MM/YYYY'"
            placeholder="Seleccione Fecha"
          />
          <a-tooltip
            title="Si selecciona una fecha, la suscripción se desactivará automáticamente en la fecha indicada."
            placement="bottom"
            ><a-icon type="question-circle-o" class="tooltip-icon" />
          </a-tooltip>
        </a-form-item>
        <!--
        <a-auto-complete
          @select="onSelect"
          @search="handleCCSearch"
          placeholder="Seleccione el codigo de curso o centro de costos"
          optionLabelProp="text"
        >
          <template slot="dataSource">
            <a-select-option
              v-for="item in costCenters"
              :key="item.id"
              :text="item.category"
            >
              {{ item.name }} \\ {{ item.product.name }}
            </a-select-option>
          </template>
          <a-input-search />
        </a-auto-complete>
        -->
        <a-form-item>
          <a-button
            v-if="isAdd"
            type="primary"
            html-type="submit"
            :loading="btnLoader"
          >
            <!--<i class="icmn-user-plus" style="margin-right:0.5em" />-->Crear
            Link de Pagos
          </a-button>

          <a-button
            v-else
            type="primary"
            html-type="submit"
            :loading="btnLoader"
          >
            <!--<i class="icmn-user-plus" style="margin-right:0.5em" />-->Guardar
          </a-button>
        </a-form-item>
      </a-form>

      <a
        href="javascript: void(0);"
        class="btn btn-link edit-paymentLink-button"
        style="margin-bottom: 0;"
      >
        <i class="icmn-cog mr-1" />
        Editar
      </a>
      <!--
      <div :class="$style.controls">
        <a-button type="primary" size="large">
          <i class="icmn-user-plus" style="margin-right:0.5em" />Suscribir
          Cliente
        </a-button>
        <a href="javascript: void(0);" class="btn btn-link">
          <i class="icmn-heart mr-1" />
          Add to Wishlist
        </a>
        <a href="javascript: void(0);" class="btn btn-link">
          <i class="icmn-stats-bars mr-1" />
          Add to Compare
        </a>
      </div>
      -->
    </a-card>
  </div>
</template>

<script>
//import { data } from "./data.json";
import { mapActions } from "vuex";
import store from "@/store";
import Vue from "vue";
import utils from "@/services/utils";

export default {
  data() {
    return {
      loading: true,
      editIcon: false,
      paymentLink: {
        id: null,
        name: null,
        description: null,
        costCenter: {
          id: null,
          name: null,
          product: { name: null }
        },
        businessUnit: {
          id: null,
          name: null
        },
        product: {
          id: null,
          name: null
        }
      },
      businessUnits: {
        group1: [],
        group2: [],
        group3: [],
        group4: [],
        noGroup: []
      },
      loadingBUs: false,
      BULoaded: false,
      costCenters: [],
      loadingCCs: false,
      costCenterDisabled: true,
      products: {
        group1: [],
        group2: [],
        all: []
      },
      filteredProducts: {
        group1: [],
        group2: [],
        all: []
      },
      loadingProducts: false,
      productsLoaded: false,
      defaultProductId: null,
      amount: { validateStatus: null, errorMsg: null },
      dateFormat: "DD/MM/YYYY",
      isAdd: false,
      isEdit: false,
      form: this.$form.createForm(this),
      btnLoader: false,
      cascaderDisabled: true,
      displayCascader: false,
      cascaderOptions: [
        {
          value: "course",
          label: "Curso",
          isLeaf: false
        },
        {
          value: "event",
          label: "Evento",
          isLeaf: false
        }
      ],
      options: []
    };
  },
  props: ["paymentLinkId"],
  methods: {
    ...mapActions({
      loadPaymentLink: "paymentLinks/loadOne",
      savePaymentLink: "paymentLinks/save",
      addPaymentLink: "paymentLinks/add",
      deletePaymentLink: "paymentLinks/delete"
    }),
    backButton() {
      if (this.$route.name == "paymentLinkAdd") {
        this.$router.push(`/payment-links`);
      } //is in edit mode
      else this.$router.push(`/payment-links/${this.paymentLink.id}`);
    },
    async fetchData() {
      try {
        //console.log("params:", params);
        //const id = this.$router.params.id
        this.loading = true;
        const result = await this.loadPaymentLink(this.$route.params.id);
        this.paymentLink = store.state.paymentLinks.record;
        this.defaultProductId = this.paymentLink.product.id.toString();
        await this.loadProducts(null);
        await this.loadCostCenters(null);
        await this.loadBusinessUnits(null);

        this.form.setFieldsValue({
          name: this.paymentLink.name,
          description: this.paymentLink.description,
          amount: this.paymentLink.amount,
          endDate: this.paymentLink.endDate
            ? this.$moment(this.paymentLink.endDate)
            : null,
          productId: this.paymentLink.product.id.toString(),
          costCenterERPCode: this.paymentLink.costCenter.ERPCode,
          businessUnitId: this.paymentLink.businessUnit.id.toString()
        });
        if (this.costCenters.length == 1) this.costCenterDisabled = true;

        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.$notification["warning"]({
          message: error.code,
          description: error.message
        });
      }
    },
    formatDate(date) {
      if (date) {
        const d = new Date(date);
        return d.toLocaleDateString();
      } else return null;
    },
    async handleSubmit(e) {
      try {
        let paymentLink, paymentLinkId;
        e.preventDefault();
        this.btnLoader = true;
        //this.validateAmount(this.form.getFieldValue("amount"));

        await this.form.validateFields(async (err, values) => {
          try {
            if (!err) {
              console.log("Received values of form: ", values);
              //seleccionó un centro de costos de harmony
              if (values.costCenterERPCode === undefined) {
                values.costCenterERPCode = values.costCenter[1];
              }
              paymentLink = values;

              if (this.isAdd) {
                paymentLinkId = await this.addPaymentLink(paymentLink);
                const c = 10;
                this.$store.commit("paymentLinks/SET_LIST_UPDATED", true);
                this.$router.push(`/payment-links/${paymentLinkId}`);
              } else {
                paymentLink.id = this.paymentLink.id;
                await this.savePaymentLink(paymentLink);
                this.paymentLink = store.state.paymentLinks.record;
                this.$router.push(`/payment-links/${this.paymentLink.id}`);
              }
            } else throw new Error("Error de validación.");
          } catch (err) {
            //el catch esta duplicado porque dentro de validateFields no bubblea al parent catch
            const x = 10;
            this.btnLoader = false;
            let message = err.message
              ? err.message
              : "Hubo un error al guardar el Link de Pagos";
            let code = err.code ? err.code : "Error";

            this.$notification["warning"]({
              message: code,
              description: message
            });
          }
        });
        this.btnLoader = false;
      } catch (err) {
        this.btnLoader = false;
        let message = err.message
          ? err.message
          : "Hubo un error al crear el Link de Pagos";
        let code = err.code ? err.code : "Error";
        console.log(err);
        this.$notification["warning"]({
          message: code,
          description: message
        });
      }
    },
    handleIsEdit() {
      this.isEdit = true;

      //alert("hola");
    },
    async loadBusinessUnits(value) {
      if (!this.BULoaded) {
        this.loadingBUs = true;
        try {
          const res = await Vue.prototype.$axios.get(
            `/admin/business-units?pageSize=100&orderBy=name`
          );
          if (res.data) {
            const options = {
              group1: [],
              group2: [],
              group3: [],
              noGroup: []
            };
            res.data.results.forEach(item => {
              let option = {
                id: item.id.toString(),
                name: item.name,
                ERPCode: item.ERPCode
              };
              if (item.groupName.toLowerCase() == "sedes")
                options.group1.push(option);
              else if (item.groupName.toLowerCase() == "oficinas")
                options.group2.push(option);
              else if (item.groupName.toLowerCase() == "zonas")
                options.group3.push(option);
              else if (item.groupName.toLowerCase() == "paises")
                options.group4.push(option);
              else options.noGroup.push(option);
            });
            this.businessUnits = options;
            this.loadingBUs = false;
            this.BULoaded = true;
          }
        } catch (error) {
          this.loadingBUs = false;
          console.log(error);
          throw error;
        }
      }
    },
    async handleCostCenterChange(val) {
      if (val == "-1") {
        //new harmony costCenter
        this.displayCascader = true;
        this.cascaderDisabled = false;
        this.$refs.businessUnitSelect.focus();
      }
    },
    async loadCostCenters(val) {
      let defaultProduct = "";
      if (this.defaultProductId)
        defaultProduct = `&defaultProductId=${this.defaultProductId}`;
      //if (this.costCenters.length == 0) {
      this.loadingCCs = true;
      this.costCenters = [];
      this.costCenterDisabled = false;
      this.form.setFieldsValue({
        costCenterERPCode: null
      });
      this.form.resetFields({ names: "costCenterERPCode" });
      try {
        const res = await Vue.prototype.$axios.get(
          `/admin/cost-centers?pageSize=1000${defaultProduct}`
        );
        if (res.data.results) {
          const options = new Array();
          res.data.results.forEach(item => {
            options.push({
              id: item.id.toString(),
              name: item.name,
              ERPCode: item.ERPCode
            });
          });
          //agregar la opcion de codigo de harmony solo si encontró más de una opción (sino significa que tiene un defaultProductId y se va a autoseleccionar)
          if (!(res.data.results.length == 1 && this.defaultProductId)) {
            options.push({
              id: "-1",
              name: "NUEVO CODIGO DE HARMONY",
              ERPCode: "-1"
            });
          }
          this.costCenters = options;
          this.loadingCCs = false;
        }
      } catch (error) {
        this.loadingCCs = false;
        console.log(error);
        throw error;
      }

      //}
    },

    filterProducts(input, option) {
      if (option.componentOptions.tag == "a-select-opt-group") return false;

      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    productsSearch(keyword) {
      this.filteredProducts.group1 = this.products.group1.filter(
        product =>
          product.name.toLowerCase().indexOf(keyword.toLowerCase()) >= 0
      );
      this.filteredProducts.group2 = this.products.group2.filter(
        product =>
          product.name.toLowerCase().indexOf(keyword.toLowerCase()) >= 0
      );
      const x = 10;
    },
    async handleProductChange(val) {
      this.defaultProductId = val;
      let harmonyCode = this.products.all.find(product => product.id == val)
        .harmonyCode;
      const x = 10;
      if (harmonyCode === null) {
        this.displayCascader = false;
        await this.loadCostCenters(val);
        //si solo hay un resultado, seleccionarlo automaticamente
        if (this.costCenters.length == 1) {
          this.form.setFieldsValue({
            costCenterERPCode: this.costCenters[0].ERPCode
          });
          this.costCenterDisabled = true;
        }
      } else {
        this.cascaderOptions = [
          {
            value: "course",
            label: "Curso",
            isLeaf: false
          },
          {
            value: "event",
            label: "Evento",
            isLeaf: false
          }
        ];
        this.displayCascader = true;
        this.cascaderDisabled = false;
      }
    },
    async loadProducts(value) {
      if (!this.productsLoaded) {
        this.loadingProducts = true;
        try {
          const res = await Vue.prototype.$axios.get(`/admin/products`);
          if (res.data) {
            //const options = new Array();
            const options = {
              group1: [],
              group2: [],
              all: []
            };
            res.data.results.forEach(item => {
              let option = {
                id: item.id.toString(),
                name: item.name,
                ERPCode: item.ERPCode,
                harmonyCode: item.harmonyCode
              };

              options.all.push(option);
              if (item.isSubscription) options.group1.push(option);
              else options.group2.push(option);
            });
            this.products = options;
            this.filteredProducts = options;
            this.loadingProducts = false;
            this.productsLoaded = true;
          }
        } catch (error) {
          this.loadingProducts = false;
          console.log(error);
          throw error;
        }
      }
    },
    async loadCascaderData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1];
      targetOption.loading = true;
      let res, offset, limit, totalPages, options, tempOptions;
      try {
        if (targetOption.value == "tupaggo") {
          res = await Vue.prototype.$axios.get(
            `/admin/cost-centers?defaultProductId=${this.defaultProductId}`
          );
          if (res.data) {
            options = new Array();
            res.data.results.forEach(item => {
              options.push({
                label: item.name,
                value: item.ERPCode,
                defaultProductId: item.defaultProductId
              });
            });
          }
        } else if (targetOption.value == "course") {
          offset = 1; //en harmony offset es el page
          limit = 100;
          totalPages = 1;
          tempOptions = new Array();

          Vue.prototype.$axiosHarmony.defaults.headers.common["Authorization"] =
            process.env.VUE_APP_HARMONY_COURSES_SEARCH_API_KEY;

          let harmonyProductCode = this.products.all.find(
            product => product.id == this.defaultProductId
          ).harmonyCode;

          for (offset = 1; offset <= totalPages; offset++) {
            res = await Vue.prototype.$axiosHarmony.get(`/courses`, {
              params: {
                type: "country",
                country: "ar",
                language: "es-ar",
                mctype: harmonyProductCode,
                status: "all",
                limit,
                offset
              }
            });
            if (res.data) {
              /*res.data.courses.forEach(item => {
                if (!tempOptions[item.title])
                  tempOptions[item.title] = new Array();
                if (item.course_id.trim() != "") {
                  tempOptions[item.title].push({
                    label: `${item.title} - ${item.course_id}`,
                    value: item.course_id
                  });
                }
              });*/
              res.data.courses.forEach(item => {
                if (item.course_id.trim() != "") {
                  let teachers = "";
                  if (item.teachers) {
                    item.teachers.forEach(teacher => {
                      let names = teacher.split(" ");
                      if (names.length == 3) {
                        //sacar el segundo nombre. Ej: Andres Alejandro Torres
                        teacher = `${names[0]} ${names[2]}`;
                      }
                      teachers += utils.capitalize(teacher) + ", ";
                    });
                    teachers = teachers.substring(0, teachers.length - 2);
                  } else {
                    if (item.contact_name) {
                      teachers = utils.capitalize(item.contact_name);
                    }
                  }
                  tempOptions.push({
                    label: `${this.$moment(item.start_date).format("DD/MM")}: ${
                      item.course_id
                    } - ${teachers}`,
                    value: item.course_id,
                    date: this.$moment(item.start_date).format("YYYY-MM-DD")
                  });
                }
              });
              totalPages = Math.ceil(res.data.total / limit);
            }
          }
          /*tempOptions.sort((a, b) => {
            if (a.label.toLowerCase() < b.label.toLowerCase()) {
              return -1;
            } else return 1;
          });*/
          if (tempOptions.length == 0) {
            //no se encontraron resultados
            tempOptions.push({
              label: "No se encontraron resultados.",
              value: null
            });
          } else {
            //sort by date
            tempOptions.sort((a, b) => {
              if (a.date < b.date) {
                return -1;
              } else return 1;
            });
          }

          options = tempOptions;
        } else if (targetOption.value == "event") {
          offset = 1;
          limit = 100;
          totalPages = 1;
          tempOptions = new Array();

          Vue.prototype.$axiosHarmony.defaults.headers.common["Authorization"] =
            process.env.VUE_APP_HARMONY_EVENTS_SEARCH_API_KEY;

          for (offset = 1; offset <= totalPages; offset++) {
            res = await Vue.prototype.$axiosHarmony.get(`/events`, {
              params: {
                type: "country",
                country: "ar",
                limit,
                offset
              }
            });
            if (res.data) {
              res.data.courses.forEach(item => {
                if (item.course_id.trim() != "") {
                  tempOptions.push({
                    label: `${item.title} - ${item.course_id}`,
                    value: item.course_id
                  });
                }
              });
              totalPages = Math.ceil(res.data.total / limit);
            }
          }
          tempOptions.sort((a, b) => {
            if (a.label.toLowerCase() < b.label.toLowerCase()) {
              return -1;
            } else return 1;
          });
          options = tempOptions;
        }
        targetOption.children = options;
        this.cascaderOptions = [...this.cascaderOptions];
        targetOption.loading = false;
      } catch (error) {
        targetOption.loading = false;
        console.log(error);
        throw error;
      }
    },
    handleRoute() {
      if (this.$route.name == "paymentLinkAdd") {
        this.isAdd = true;
      } else if (this.$route.name == "paymentLinkEdit") {
        this.isEdit = true;
        this.fetchData();
      }
    }
  },
  mounted() {
    this.handleRoute();
  },
  watch: {
    //REACTIVE TO URL CHANGE
    $route(to) {
      this.handleRoute();
    }
  }
};
</script>

<style lang="scss" module>
@import "./index.module.scss";
</style>

<style lang="css">
.anticon {
  vertical-align: -2px;
}
.ant-card {
  border-radius: 7px;
}
.ant-card-head-title {
  text-transform: uppercase;
  font-weight: bold;
  font-size: 2rem;
}
.ant-card-body {
  padding-bottom: 9px;
}
.ant-form-item-control-wrapper {
  /*white-space: nowrap;*/
}
.ant-cascader-menu-item {
  text-transform: capitalize;
}
.back-button {
  /*background-color: #fff;
  border-color: #777;
  color: #777;*/
  vertical-align: 0.38rem;
}
.back-button .anticon {
  vertical-align: -0.213rem;
}
.ant-collapse-item {
  border-bottom: none !important;
}
.add-form {
  width: 30rem;
}
.tooltip-icon {
  color: #ccc;
  margin-left: 0.5rem;
}
.tooltip-top {
  position: absolute;
  top: 2px;
  right: -19px;
}
@media (max-width: 767px) {
  .ant-card-head-wrapper {
    flex-direction: column-reverse !important;
    align-items: flex-start;
  }
  .ant-card-head-title {
    flex-grow: 5;
    /*font-size: 100%;*/
    width: 25rem;
  }
  .ant-card-extra {
    float: inherit !important;
    margin-left: inherit !important;
    align-self: flex-end;
  }
  .add-form {
    width: inherit;
  }
  .ant-switch {
    margin-left: 0 !important;
  }
  .title-id {
    display: none;
  }
  .hover-title {
    font-size: 1.7rem;
    letter-spacing: -1px;
  }
  .hover-title + .edit-icon {
    display: inline;
  }
  .edit-paymentLink-button {
    display: inline !important;
  }
}
.edit-paymentLink-button {
  display: none;
}
.edit-icon {
  display: none;
}
.hover-title {
  cursor: pointer;
}
.hover-title:hover + .edit-icon {
  display: inline;
}
</style>
